import { put, select } from 'redux-saga/effects';
import { setDirtyState } from 'data/templates';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import { addUpdateTemplateDraftIndexedDb } from 'hooks/use-idb';
import { denormalizePayload } from '../api/transform';
import { getDocumentTemplateStore } from '../selectors';
export const getTemplateId = (path)=>{
    if (!path.startsWith('/templates')) {
        return null;
    }
    const segments = path.split('/');
    /**
   * /templates/projects/:id
   * /templates/documents/:id
   * /templates/projects/folder/:folderId/:id
   * /templates/documents/folder/:folderId/:id
   */ const id = segments[3] === 'folder' ? segments[5] : segments[3];
    if (id === 'new') {
        return 'new';
    }
    const templateId = Number.isFinite(parseInt(id, 10)) ? parseInt(id, 10) : null;
    return templateId;
};
export function* saveDocumentTemplate(docId, sync) {
    const payloadToNormalize = yield select(getDocumentTemplateStore(docId));
    const id = getTemplateId(window.location.pathname);
    if (payloadToNormalize) {
        const denormalizedDocumentTemplate = denormalizePayload(payloadToNormalize);
        if (sync) {
            const payload = yield TemplatesAPI.save(denormalizedDocumentTemplate);
            if (id != null) {
                yield put(setDirtyState({
                    id,
                    _state: false
                }));
            }
            return payload;
        }
        if (id != null) {
            yield put(setDirtyState({
                id,
                _state: true
            }));
        }
        // whenever a store update is made for document updates, it should be saved in idb as well
        yield addUpdateTemplateDraftIndexedDb(parseInt(String(docId), 10), denormalizedDocumentTemplate, TemplateObjectType.Document);
        return denormalizedDocumentTemplate;
    }
    return null;
}
